// extracted by mini-css-extract-plugin
export var project_content = "ProjectContent-module--project_content--liiuT";
export var project_content_title = "ProjectContent-module--project_content_title--PDsXL";